"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var DEFAULTS = {
  lockedBy: null,
  lockedSession: null,
  lockedUntil: null,
  status: _constants.RequestStatus.UNINITIALIZED,
  toastDismissed: false
};

var Lock = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Lock, _Record);

  function Lock() {
    (0, _classCallCheck2.default)(this, Lock);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Lock).apply(this, arguments));
  }

  (0, _createClass2.default)(Lock, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      var lockedBy = data.lockedBy,
          lockedSession = data.lockedSession,
          lockedUntil = data.lockedUntil,
          status = data.status;
      return new Lock({
        lockedBy: lockedBy || -1,
        lockedSession: lockedSession || null,
        lockedUntil: lockedUntil || _I18n.default.moment().add(2, 'minutes').valueOf(),
        status: status || _constants.RequestStatus.SUCCEEDED
      });
    }
  }]);
  return Lock;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Lock;
module.exports = exports.default;